<template>
  <div>
    <v-toolbar dense tabs color="primary darken-2" dark>
      <v-toolbar-title class="pl-2">
        <a href="javascript: history.go(-1)" class="pa-0">
          <v-btn flat fab small class="pa-0">
            <i class="fas fa-arrow-left headline"></i>
          </v-btn>
        </a>
        Let's grow together
      </v-toolbar-title>
    </v-toolbar>

    <div class="signup-wrapper">
      <v-container class="form-container">
        <v-card class="signup-card" elevation="4">
          <!-- En-tête -->
          <div class="header">
            <h2 class="subtitle" style="font-weight: 700;">Affiliate a new user</h2>
            <div class="divider"></div>
          </div>

          <v-form @submit.prevent="submitForm">
            <!-- Champ Nom complet -->
            <div class="name-fields">
              <v-layout row>
                <v-flex xs2 sm1>
                  <i class="teal--text fas fa-user fa-2x mt-2"></i>
                </v-flex>
                <v-flex xs10 sm10>
                  <v-text-field
                    v-model="form.name"
                    label="Full name"
                    outlined
                    dense
                    :rules="[v => !!v || 'Name is required']"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    @click.stop="showFieldHelp('fullnames')"
                    flat fab small outline color="black"
                    class="my-3"
                    style="height:20px; width: 20px"
                  >
                    <i class="fas fa-question small-question"></i>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <!-- Champ Nom d'utilisateur -->
            <div class="name-fields">
              <v-layout row>
                <v-flex xs2 sm1>
                  <i class="teal--text fas fa-user-circle fa-2x mt-2"></i>
                </v-flex>
                <v-flex xs10 sm10>
                  <v-text-field
                    v-model="form.username"
                    label="Username"
                    :rules="usernameRules"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    @click.stop="showFieldHelp('username')"
                    flat fab small outline color="black"
                    class="my-3"
                    style="height:20px; width: 20px"
                  >
                    <i class="fas fa-question small-question"></i>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <!-- Champ Email -->
            <div class="name-fields">
              <v-layout row>
                <v-flex xs2 sm1>
                  <i class="teal--text fas fa-envelope fa-2x mt-2"></i>
                </v-flex>
                <v-flex xs10 sm10>
                  <v-text-field
                    v-model="form.email"
                    label="Email address"
                    :rules="emailRules"
                    outlined
                    dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    @click.stop="showFieldHelp('email')"
                    flat fab small outline color="black"
                    class="my-3"
                    style="height:20px; width: 20px"
                  >
                    <i class="fas fa-question small-question"></i>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <!-- Champ Téléphone -->
            <div class="name-fields">
              <v-layout row>
                <v-flex xs2 sm1>
                  <i class="teal--text fas fa-phone fa-2x mt-2"></i>
                </v-flex>
                <v-flex xs10 sm10>
                  <input
                    @click="clearPhoneField()"
                    id="phone"
                    required
                    type="tel"
                    value="Enter Phone Number"
                    v-model="phone_number"
                    ref="phone_number"
                    name="phone"
                    class="py-2 my-2"
                    style="width: 100%!important; border-bottom: 1px grey solid"
                  />
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    @click.stop="showFieldHelp('phone')"
                    flat fab small outline color="black"
                    class="my-3"
                    style="height:20px; width: 20px"
                  >
                    <i class="fas fa-question"></i>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <!-- Message informatif sur le mot de passe -->
            <v-alert
              type="info"
              outlined
              dense
              class="my-3"
              icon="mdi-lock-reset"
            >
              <strong>🔐 Secure Password Generation</strong><br>
              A secure password will be automatically generated and sent to the user's email address.
            </v-alert>

            <!-- Champ Référence (nouveau système) -->
            <div class="name-fields">
              <ReferralField
                v-model="referralCode"
                :state="referralState"
                :ownerName="referralOwnerName"
                :locked="referralLocked"
                @input="onReferralInput"
              />
            </div>

            <v-btn
              block
              @click="submitForm"
              color="teal"
              class="signup-btn"
              type="submit"
            >
              Next
            </v-btn>
          </v-form>

          <!-- Lien de connexion -->
          <div class="login-link">
            Already have an account? <a href="/login">Log In</a>
          </div>
        </v-card>
      </v-container>

      <!-- Dialog de paiement -->
      <v-dialog width="500px" v-model="showPayment">
        <v-card>
          <v-card-title class="headline primary darken-2 white--text" primary-title>
            Confirm Deposit
          </v-card-title>

          <v-card-text class="pa-4">
            <div class="name-fields">
              <v-layout row>
                <v-flex xs2 sm1>
                  <i class="teal--text fas fa-phone fa-2x mt-2"></i>
                </v-flex>
                <v-flex xs10 sm10>
                  <input
                    id="transactionPhone"
                    type="tel"
                    @click="clearTransactionPhoneField()"
                    class="py-2 my-2"
                    style="width: 100%!important; border-bottom: 1px grey solid"
                  />
                </v-flex>
                <v-flex xs1>
                  <v-btn
                    @click.stop="showFieldHelp('transaction_phone')"
                    flat fab small outline color="black"
                    class="my-3"
                    style="height:20px; width: 20px"
                  >
                    <i class="fas fa-question"></i>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>

            <v-layout row wrap class="mb-4">
              <v-flex xs6 class="text-center">
                <v-card
                  @click="selectOperator('MTN')"
                  :class="{ 'selected-operator': paymentMethod === 'MTN' }"
                  class="pa-2 operator-card"
                >
                  <v-img
                    :src="require('@/assets/mtn-mobile-money-logo.png')"
                    contain height="60"
                  ></v-img>
                </v-card>
              </v-flex>

              <v-flex xs6 class="text-center">
                <v-card
                  @click="selectOperator('OM')"
                  :class="{ 'selected-operator': paymentMethod === 'OM' }"
                  class="pa-2 operator-card"
                >
                  <v-img
                    :src="require('@/assets/om.png')"
                    contain height="60"
                  ></v-img>
                </v-card>
              </v-flex>
            </v-layout>

            <p class="mb-0">
              By clicking <b class="teal--text darken-2">Confirm</b>, a deposit transaction of
              <b>10500 F CFA</b> will be triggered through
              <b v-if="paymentMethod">{{ paymentMethod === 'MTN' ? 'MTN Mobile Money' : 'Orange Money' }}</b>
              <b v-else class="red--text">[ select payment method]</b>
              from the phone number <b>{{ transactionPhoneNumber }}</b>
              <b v-if="!transactionPhoneNumber" class="red--text">[phone number]</b>
            </p>

            <div v-if="paymentMethod" class="mt-3">
              <p class="mb-0">If you are facing difficulties, send manually through the code below:</p>
              <p class="pl-2 mb-0 pt-1 red--text">
                - <b>{{ ussdCode }}</b>
                <v-btn
                  icon
                  @click="copyUSSD"
                  class="ml-2"
                  title="Copy USSD code"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </p>

              <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'MTN'">
                - Choose reference 1
              </p>
              <p class="pl-2 mb-0 pt-1" v-if="paymentMethod === 'OM'">
                - Input transaction amount
              </p>
              <p class="pl-2 mb-0 pt-1">
                - Always <b class="teal--text darken-2">Confirm</b> below
              </p>
            </div>
          </v-card-text>

          <v-card-actions class="px-3">
            <v-btn color="teal" text @click="showPayment = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="teal darken-2"
              class="white--text"
              @click="handlePaymentConfirmation"
              :disabled="!paymentMethod || !transactionPhoneNumber"
              :loading="processingPayment"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import referralMixin from '@/mixins/referralMixin';
import ReferralField from '@/components/ReferralField.vue';

export default {
  mixins: [referralMixin],
  components: { ReferralField },
  data() {
    return {
      form: {
        name: '',
        username: '',
        email: '',
      },
      showPayment: false,
      paymentMethod: '',
      transfer_code: '',
      transactionPhoneNumber: '',
      transactionId: '',
      ussdCode: '',
      hrefTel: '',
      phone_number: "Enter Phone Number",
      phoneInput: null,
      transactionPhoneInput: null,
      processingPayment: false,
      usernameRules: [
        v => !!v || 'Username is required',
        v => (v && v.length >= 4) || 'Username must be at least 4 characters',
      ],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid',
      ],
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },

  mounted() {
    this.fetchSponsorSerial();
    this.initialiseIntel();
  },

  watch: {
    showPayment(newVal) {
      if (newVal) {
        this.$nextTick(() => this.initialiseTransactionIntel());
      }
    },
  },

  methods: {
    showFieldHelp(field) {
      const helpMessages = {
        fullnames: {
          title: "Full Names",
          message: "Here you are required to input all your names."
        },
        username: {
          title: "Your User Name",
          message: "Here you are required to input your User Name."
        },
        email: {
          title: "Why have an email",
          message: "Your email will allow us to send you information, notifications regarding your business suite, and your secure password."
        },
        phone: {
          title: "Your Phone Number",
          message: "Please input your phone number. This number will be used for sending money and validating transactions."
        },
        reference: {
          title: "Who Referred You",
          message: "This allows you to sponsor another user once you have a business suite."
        },
        transaction_phone: {
          title: "Transaction Phone",
          message: "Phone number that will be used for this payment transaction."
        }
      };

      const help = helpMessages[field];
      if (help) {
        this.$store.commit('setDialogTitle', help.title);
        this.$store.commit('setDialogMessage', help.message);
        this.$store.commit('activateDialog', true);
      }
    },

    async fetchSponsorSerial() {
      try {
        const response = await axios.get('/api/v1/savings/sponsor/serial/', {
          headers: {
            Authorization: `Token ${this.$store.state.token}`
          }
        });

        if (response.data.success && response.data.serial_no) {
          // 🎯 ASSIGNER LE CODE AU MIXIN POUR QU'IL LE VÉRIFIE
          this.referralCode = response.data.serial_no;
          this.referralLocked = true;
          console.log('✅ Sponsor serial loaded:', response.data.serial_no);
          // Le mixin va vérifier automatiquement le code via _verifyReferralCode()
          this._verifyReferralCode(response.data.serial_no);
        } else {
          this.showSnackbar('User not found', 'error');
        }
      } catch (error) {
        console.error('Error:', error);
        this.showSnackbar('Failed to recover sponsor', 'error');
      }
    },

    initialiseIntel() {
      function getIp(callback) {
        fetch('https://ipinfo.io/json?token=fa5e74d3e65812', {
          headers: { 'Accept': 'application/json' }
        })
        .then((resp) => resp.json())
        .catch(() => ({ country: 'cm' }))
        .then((resp) => callback(resp.country));
      }

      const phoneInputField = document.querySelector("#phone");
      this.phoneInput = window.intlTelInput(phoneInputField, {
        initialCountry: "cm",
        geoIpLookup: getIp,
        preferredCountries: ["cm", "us", "uk", "ci", "cg", "cf", "td", "ng", "gq", "ga"],
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });
    },

    clearPhoneField() {
      if (this.phone_number === "Enter Phone Number") {
        this.phone_number = "";
      }
    },

    initialiseTransactionIntel() {
      const transactionPhoneInputField = document.querySelector("#transactionPhone");
      this.transactionPhoneInput = window.intlTelInput(transactionPhoneInputField, {
        initialCountry: "cm",
        geoIpLookup: (callback) => {
          fetch('https://ipinfo.io/json?token=fa5e74d3e65812', {
            headers: { 'Accept': 'application/json' }
          })
          .then((resp) => resp.json())
          .catch(() => ({ country: 'cm' }))
          .then((resp) => callback(resp.country));
        },
        preferredCountries: ["cm", "us", "uk", "ci", "cg", "cf", "td", "ng", "gq", "ga"],
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });

      transactionPhoneInputField.addEventListener('input', () => {
        this.transactionPhoneNumber = this.transactionPhoneInput.getNumber();
      });
    },

    clearTransactionPhoneField() {
      if (this.transactionPhoneInput?.getNumber() === "Enter Phone Number") {
        this.transactionPhoneInput.setNumber("");
      }
    },

    async submitForm() {
      // Validations
      if (this.form.name.length < 2) {
        this.showSnackbar('Your name is too short, please input at least 2 of your names', 'error');
        return;
      }

      if (this.form.username.length < 4) {
        this.showSnackbar('Username is too short, needs to be at least 4 characters', 'error');
        return;
      }

      if (!this.form.email) {
        this.showSnackbar('Email is required', 'error');
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.form.email)) {
        this.showSnackbar('Email must be valid', 'error');
        return;
      }

      if (!this.phoneInput?.isValidNumber?.()) {
        this.showSnackbar('Phone number is invalid. Please input a valid number', 'error');
        return;
      }

      try {
        const response = await axios.post('/api/v1/home/validate-credentials/', {
          username: this.form.username,
          phone: this.phoneInput.getNumber(),
          email: this.form.email,
          skip_password_validation: true
        });

        if (response.data?.error) {
          this.showSnackbar(response.data.error, 'error');
          return;
        }

        this.showPayment = true;
        this.showSnackbar(
          'Please enter your transaction number and select the payment method between Orange Money or MTN Momo.',
          'info'
        );

        this.paymentMethod = '';
        this.ussdCode = '';
        this.transactionId = '';
        this.transactionPhoneNumber = '';

      } catch (error) {
        const errorMessage = error.response?.data?.error || 'An unexpected error occurred';
        this.showSnackbar(errorMessage, 'error');
      }
    },

    selectOperator(operator) {
      this.paymentMethod = operator;
      this.generateUSSD();
      this.transactionId = this.generateTransactionId();
      this.showSnackbar(
        `Selected payment method: ${operator === 'MTN' ? 'MTN Mobile Money' : 'Orange Money'}`,
        'info'
      );
    },

    generateTransactionId() {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 1000);
      return `${this.paymentMethod}-${timestamp}-${random}`;
    },

    generateUSSD() {
      const amount = 10500;

      if (this.paymentMethod === "MTN") {
        this.ussdCode = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}#`;
        this.transfer_code = `*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
        this.hrefTel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${amount}%23`;
      } else if (this.paymentMethod === "OM") {
        this.transfer_code = `%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
        this.ussdCode = `#150*47*${this.$store.state.MerchantCodeOrange}*${amount}#`;
        this.hrefTel = `tel:%23150*47*${this.$store.state.MerchantCodeOrange}*${amount}%23`;
      }
    },

    async handlePaymentConfirmation() {
      if (!this.paymentMethod) {
        this.showSnackbar('Please select payment operator', 'error');
        return;
      }

      if (!this.transactionPhoneInput?.isValidNumber()) {
        this.showSnackbar('Phone number is invalid. Please input a valid number', 'error');
        return;
      }

      try {
        this.generateUSSD();
        window.location.href = this.hrefTel;

        await this.confirmPayment();

        setTimeout(() => {
          if (!document.hidden) {
            window.open(this.hrefTel, '_blank');
          }
        }, 200);

      } catch (error) {
        this.showSnackbar(error.message, 'error');
      }
    },

    async confirmPayment() {
      this.processingPayment = true;

      try {
        const payload = {
          fullnames: this.form.name,
          username: this.form.username,
          phone_number: this.phoneInput.getNumber(),
          payment_method: this.paymentMethod,
          email: this.form.email,
          transaction_id: this.transactionId,
          transaction_phone: this.transactionPhoneInput.getNumber(),
          serial_no: this.getReferralPayload()
        };

        const response = await axios.post('/api/v1/savings/referred/business-account/', payload);

        if (response.data.password_generated) {
          this.showSnackbar(
            '🎉 Account created successfully! A secure password has been generated and sent to the user\'s email. Redirecting...',
            'success'
          );
        } else {
          this.showSnackbar(
            '🎉 Your account has been successfully created! You will receive a confirmation email after verification. Redirecting...',
            'success'
          );
        }

        setTimeout(() => {
          this.$router.push({
            path: '/business-account/dashboard/client-of-affiliates',
          });
          this.resetForm();
          this.showPayment = false;
        }, 6000);

      } catch (error) {
        const message = error.response?.data?.error || 'An error occurred';
        this.showSnackbar(message, 'error');
        console.error('API Error:', error.response?.data || error.message);
      } finally {
        this.processingPayment = false;
      }
    },

    copyUSSD() {
      navigator.clipboard.writeText(this.ussdCode);
      this.showSnackbar('USSD code copied to clipboard!', 'success');
    },

    resetForm() {
      this.form = {
        name: '',
        username: '',
        email: '',
      };
      this.transactionPhoneNumber = '';
    },

    showSnackbar(message, type) {
      const colors = {
        error: 'red darken-4',
        success: 'teal darken-2',
        info: 'teal darken-2'
      };

      this.$store.commit('setSnackBarMessage', message);
      this.$store.commit('setSnackBarColor', colors[type] || 'teal darken-2');
      this.$store.commit('activateSnackBar', true);
    },
  }
};
</script>

<style scoped>
.selected-operator {
  border: 2px solid #009688 !important;
  background-color: #e0f2f1 !important;
}

.operator-card {
  cursor: pointer;
  transition: transform 0.3s ease;
  border: 2px solid transparent;
}

.operator-card:hover {
  transform: scale(1.05);
}

.signup-wrapper {
  background: #f0f2f5;
  min-height: 100vh;
  padding: 72px 0 112px;
}

.form-container {
  max-width: 432px;
  margin: 0 auto;
}

.signup-card {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 24px;
}

.subtitle {
  text-align: center;
  font-size: 24px;
  margin-bottom: 16px;
  color: #333;
}

.divider {
  height: 2px;
  background: linear-gradient(135deg, #009688, #00695c);
  margin-bottom: 24px;
  border-radius: 1px;
}

.signup-btn {
  margin-top: 24px !important;
  padding: 12px !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.login-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.login-link a {
  color: #009688;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s;
}

.login-link a:hover {
  color: #00796b;
  text-decoration: underline;
}

.name-fields {
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .signup-wrapper {
    padding: 56px 0 80px;
  }

  .form-container {
    max-width: 100%;
    padding: 0 12px;
  }

  .signup-card {
    padding: 16px;
  }

  .subtitle {
    font-size: 20px;
    margin-bottom: 12px;
  }
}
</style>
